var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElephant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 187,
    viewBox: "0 0 159 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_461)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40_461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.61 120.34C34.45 144.32 55.8 171.15 82.35 171.33C108.91 171.51 130.62 144.98 130.78 120.99C130.94 97.01 109.5 84.65 82.94 84.47C56.38 84.29 34.77 96.35 34.6 120.33L34.61 120.34Z",
    fill: "url(#paint0_linear_40_461)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.277 96.4989L117.268 96.5034C112.277 98.9932 110.249 105.058 112.739 110.05L125.009 134.649C127.499 139.641 133.563 141.669 138.555 139.179L138.564 139.175C143.556 136.685 145.584 130.62 143.094 125.628L130.824 101.029C128.334 96.0372 122.269 94.0091 117.277 96.4989Z",
    fill: "url(#paint1_linear_40_461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2056 81.9621L15.1973 81.9676C10.5501 85.0529 9.28392 91.3212 12.3692 95.9684L31.5673 124.886C34.6525 129.533 40.9209 130.799 45.5681 127.714L45.5764 127.708C50.2236 124.623 51.4898 118.355 48.4045 113.708L29.2064 84.7902C26.1212 80.1431 19.8528 78.8769 15.2056 81.9621Z",
    fill: "url(#paint2_linear_40_461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 24.01L35.27 14.25C30.37 11.26 24.21 11.24 19.29 14.2C10.98 19.18 4.73 26.97 1.67 36.16C-3.41 51.39 3.39 68.04 17.67 75.36L33.55 83.5L51.29 24.01H51.3Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3 33.04L34.97 24.93C30.89 22.45 25.77 22.43 21.68 24.89C14.78 29.03 9.58 35.51 7.04 43.14C2.82 55.8 8.47 69.64 20.35 75.73L33.55 82.5L48.3 33.04Z",
    fill: "url(#paint3_linear_40_461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 24.01L123.03 14.25C127.93 11.26 134.09 11.24 139.01 14.2C147.31 19.18 153.56 26.97 156.62 36.15C161.7 51.38 154.9 68.03 140.62 75.35L124.74 83.49L107 24V24.01Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 33.04L123.33 24.93C127.41 22.45 132.53 22.43 136.62 24.89C143.52 29.03 148.72 35.51 151.26 43.14C155.48 55.8 149.83 69.64 137.95 75.73L124.75 82.5L110 33.04Z",
    fill: "url(#paint4_linear_40_461)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_40_461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.65 71.28C132.65 100.83 108.7 114.08 79.15 114.08C49.6 114.08 25.65 100.83 25.65 71.28C25.65 41.73 58.63 10 79.15 10C99.67 10 132.65 41.73 132.65 71.28Z",
    fill: "url(#paint5_linear_40_461)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_40_461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.76 13.81C72.48 17.43 72.56 27.97 72.56 27.97C72.67 28.33 73.18 28.21 73.35 28.1C74.08 27.63 75.76 25.58 75.76 25.58C75.97 25.28 76.42 25.35 76.54 25.69C76.54 25.69 77.65 29.51 77.9 32.94C77.92 33.16 78.58 33.04 78.75 32.92C80.34 31.77 81.68 25.46 81.68 25.46C81.78 25.11 82.22 25.02 82.45 25.29C82.45 25.29 84.25 26.11 85.19 28.57C85.26 28.76 85.82 28.51 85.97 28.37C88.96 25.63 90.78 15.25 88.54 12.02C85.36 7.43 63.38 10.44 67.76 13.8V13.81Z",
    fill: "#8058EA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.15 60C93.4 54.75 101.9 54.75 107.15 60",
    stroke: "#474193",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.11 85.68L96.01 85.43C103.42 83.4 110.03 79.15 114.95 73.25C116.08 71.9 118.24 72.3 118.81 73.96C120.68 79.39 122.08 88.03 115.59 92.77C105.76 99.96 97.38 92.9 94.04 89.38C92.87 88.15 93.46 86.12 95.1 85.67L95.11 85.68Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.54 77.94C67.1004 77.94 74.04 68.9857 74.04 57.94C74.04 46.8943 67.1004 37.94 58.54 37.94C49.9796 37.94 43.04 46.8943 43.04 57.94C43.04 68.9857 49.9796 77.94 58.54 77.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.54 56.38C69.54 52.514 66.406 49.38 62.54 49.38C58.674 49.38 55.54 52.514 55.54 56.38V63.38C55.54 67.246 58.674 70.38 62.54 70.38C66.406 70.38 69.54 67.246 69.54 63.38V56.38Z",
    fill: "#122431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.04 59.38C62.973 59.38 64.54 57.813 64.54 55.88C64.54 53.947 62.973 52.38 61.04 52.38C59.107 52.38 57.54 53.947 57.54 55.88C57.54 57.813 59.107 59.38 61.04 59.38Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_40_461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.02 90.95L28.22 88.7C29.13 87 31.37 86.34 32.93 87.48C33.04 87.56 36.17 93.37 38.46 95.11C40.98 97.02 45.97 97.25 50.36 93.04C56.18 87.46 56.88 78.68 60.86 75.17C67.85 69 76.28 70.02 82.12 75.09C87.96 80.16 89.16 89.56 85.02 96.15C80.9 102.72 66.33 110.52 58.9 112.64C49.78 115.24 40.69 111.05 36.7 107.99C30.32 103.12 26.09 95.62 26.09 95.62C24.31 93.88 25.52 92.01 27.03 90.95H27.02Z",
    fill: "url(#paint6_linear_40_461)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40_461",
    x: 26.6,
    y: 79.468,
    width: 112.181,
    height: 102.863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_461"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_461",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_40_461",
    x: 17.65,
    y: 5,
    width: 123,
    height: 120.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_461"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_461",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_40_461",
    x: 65.1851,
    y: 8.67892,
    width: 26.3538,
    height: 27.3837,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_461"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_461",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_40_461",
    x: 17.2044,
    y: 65.9077,
    width: 78.2653,
    height: 58.5468,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_461"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_461",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40_461",
    x1: 82.6992,
    y1: 84.4812,
    x2: 82.698,
    y2: 171.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40_461",
    x1: 127.913,
    y1: 95.4382,
    x2: 127.913,
    y2: 140.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40_461",
    x1: 32.127,
    y1: 102.692,
    x2: 47.3935,
    y2: 72.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40_461",
    x1: 48.3,
    y1: 52.78,
    x2: 5.65,
    y2: 52.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_40_461",
    x1: 110,
    y1: 52.78,
    x2: 152.65,
    y2: 52.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_40_461",
    x1: 79.15,
    y1: 114.08,
    x2: 79.15,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_40_461",
    x1: 82.7551,
    y1: 75.4329,
    x2: 34.4976,
    y2: 108.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158.3,
    height: 187,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElephant);
export default __webpack_public_path__ + "static/media/elephant.b081310575df7d7bc81fc14f21fa58bc.svg";
export { ForwardRef as ReactComponent };